import type { FormField } from '../../types';
import { FormFieldWrapper } from './FormFieldWrapper';

interface Props { field: FormField; value: unknown; onChange: (v: unknown) => void; error?: string; }
export function DropdownField({ field, value, onChange, error }: Props) {
  return (
    <FormFieldWrapper field={field} error={error} labelFor={field.fieldId}>
      <select id={field.fieldId} value={String(value ?? '')} onChange={e => onChange(e.target.value)} aria-invalid={!!error}>
        <option value="">Select...</option>
        {(field.options ?? []).map(opt => <option key={opt} value={opt}>{opt}</option>)}
      </select>
    </FormFieldWrapper>
  );
}
